import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { OrderSummary, SummaryOrderItem, SummaryOrderItemProductVariant } from '../../common/types';

interface Props {
    order: OrderSummary
}

const variantSort = (
    a: SummaryOrderItemProductVariant,
    b: SummaryOrderItemProductVariant,
): number => {
    return a.variantName.localeCompare(b.variantName);
};

const itemKey = (item: SummaryOrderItem) => {
    const chunks = [item.productName, ...item.items.sort(variantSort).map(v => `${v.variantName}${v.quantity}`)]
    return chunks.join(', ');
}

const itemName = (item: SummaryOrderItem) => {
    const chunks = [item.productName]
    if (item.hasSizes) {
        chunks.push(`(${item.sizeName})`)
    }
    return chunks.join(' ')
}

export default function OrderItemsList({ order }: Props) {

    return order.items.map((orderItem) => (
        <Stack key={itemKey(orderItem)}>
            <Divider sx={{ marginY: 1 }} />
            <Stack flexDirection="row" justifyContent="flex-start">
                <Typography fontWeight="bold">
                    {itemName(orderItem)}
                </Typography>
                <Typography fontWeight="bold" sx={{ marginLeft: 'auto' }}>
                    ${orderItem.total.toFixed(2)}
                </Typography>
            </Stack>
            {
                orderItem.noMilk && (
                    <Stack
                        flexDirection="row"
                        justifyContent="flex-start"
                    >
                        <Typography fontSize="12px">
                            - No Milk
                        </Typography>
                        <Typography fontSize="12px" sx={{ marginLeft: 'auto' }}>
                            $0.00
                        </Typography>
                    </Stack>
                )
            }
            {orderItem.items.filter(f => !f.isCore).sort(variantSort).map((variant) => (
                <Stack
                    key={`${itemKey(orderItem)}_${variant.variantName}`}
                    flexDirection="row"
                    justifyContent="flex-start"
                >
                    <Typography fontSize="12px">
                        - {variant.variantName} x {variant.quantity}
                    </Typography>
                    <Typography fontSize="12px" sx={{ marginLeft: 'auto' }}>
                        ${variant.total.toFixed(2)}
                    </Typography>
                </Stack>
            ))}
            {orderItem.notes?.length > 0 && (
                <Typography
                    fontSize="12px"
                    sx={{ flex: 1, textAlign: 'left', marginTop: 1 }}
                >
                    * {orderItem.notes}
                </Typography>
            )}
            {orderItem.quantity > 1 && (
                <Stack flexDirection="row" justifyContent="space">
                    <Typography sx={{ flex: 2, textAlign: 'right' }}>
                        x {orderItem.quantity}
                    </Typography>
                    <Typography sx={{ flex: 1, textAlign: 'right' }}>
                        ${(orderItem.total * orderItem.quantity).toFixed(2)}
                    </Typography>
                </Stack>
            )}
        </Stack>
    ))

}